import resume from '../assets/pdf/resume.pdf'
import profile_image from '../assets/svg/contacts/default.jpg'

export const headerData = {
    name: 'Coderannu',
    title: "Full Stack Web Developer",
    desciption:"I think that we have opportunities all around us - sometimes we just don't recognize them.",
    image: profile_image,
    resumePdf: resume
}
